module.exports = __webpack_public_path__ + "static/media/baia.25bef9f7.jpg";